import { Box, Container } from "@chakra-ui/react";
import VerifySection from "../sections/VerifySection";

function Verify() {
  return (
    <Box py={12} justifyContent={"center"} alignItems={"center"}>
      <Container maxW={"md"}>
        <VerifySection />
      </Container>
    </Box>
  );
}

export default Verify;